
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getServicerList } from '../../api/branch';
import { UserModule } from '../../store/modules/user';
import CustomerDialog from './components/BranchDialogCustomer.vue';

@Component({
  name: 'BranchOrderServicer',
  components: {
    CustomerDialog
  }
})
export default class extends Vue {
  private listLoading = false;
  private customerDialogVisible = false;
  private currentServicer: any = {
    servicer_company_id: ''
  };
  private orderList = []
  private total = 0;
  private listQuery: any = {
    page: 1,
    size: 10,
    total: 0
  };
  @Watch('listQuery', {
    deep: true,
    immediate: true
  })handleChangeQuery() {
    this.getServicerList();
  }
  handleCurrentChange(val: number) {
    this.listQuery.page = val;
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val;
  }
  private getServicerList() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    getServicerList(params).then(res => {
      if (res && res.data) {
        this.orderList = res.data.list;
        this.total = res.data.count;
      } else {
        this.orderList = [];
        this.total = 0;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private customerSee(row: any) {
    this.customerDialogVisible = true;
    this.currentServicer = row;
  }
  private closeDialog(val: boolean) {
    this.customerDialogVisible = val;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
